import { Tag } from 'antd';
import { createElement } from 'react';

export function channelTag(channel: string) {
  if (channel === 'Внутренние') return createElement(Tag, { color: 'gold' }, channel);
  return createElement(Tag, { color: 'processing' }, channel);
}
